import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component '" + name + "' was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`SCHOOL FEEDING`}</h2>
    <p>{`Every day, countless children across the globe turn up for school on an empty stomach, which makes it hard to focus on lessons. Many simply do not go, as their families need them to help in the fields or around the house. For all of them, having food at school every day can mean not only better nutrition and health, but also increased access to and achievement in education.`}</p>
    <p>{`WFP is the world’s largest humanitarian organisation implementing school feeding programmes. Thanks to support from donors like the EU, over 17 million children across 59 countries benefitted from nutritious meals provided by WFP in 2019.`}</p>
    <p>{`In `}<strong parentName="p">{`Egypt`}</strong>{`, the EU’s support to WFP’s local school feeding programme helped prevent child labour and incentivised families to send their children to school. Thanks to the project, children received a daily snack and their families were given monthly take-home food rations in return for regular attendance at class.`}</p>
    <p>{`WFP also helped children in `}<strong parentName="p">{`Mali`}</strong>{` continue their education and invest in their own future. Thanks to funding from donors like the EU, WFP served school meals in the areas with the lowest food security. The project empowered girls, providing incentives for parents to keep sending their daughters to school.`}</p>
    <p>{`In `}<strong parentName="p">{`South Sudan`}</strong>{`, which has the highest proportion of out-of-school children in the world, support from the EU helped WFP provide school meals to 150 schools across the country. In some cases, girls could take food home, which not only encouraged their families to keep them in school, but also reduced the risks of child labour and early marriage. `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      